export default __webpack_public_path__ + "static/media/signup-featured-mobile.49b846cdc7a2d79e533cc105fad1a243.svg";